<template functional>
<span :class="{...props.classes, ...{'text-danger': props.value.length > props.limit }}">
    {{ props.value.length }} / {{ props.limit }}
</span>
</template>

<script>
export default {
    name: 'CharacterCounter',
    props: {
        value: {
            type: String,
            default: '',
        },
        limit: {
            type: Number,
            default: 0,
        },
        classes: {
            type: Object,
            default: function(){
                return {}
            }
        }
    },
}
</script>
